import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '../../services/translate.service';
import { AuthService } from '../../../core/services/auth.service';
import { User } from '../../../core/models/user';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  constructor(
    private tSvc: TranslateService,
    private auth: AuthService,
    private router: Router,
  ) {}

  t(k: string) {
    return this.tSvc.translate(k);
  }

  get langLabel() {
    return this.tSvc.current === 'en' ? 'BG' : 'EN';
  }

  toggleLang() {
    this.tSvc.current = this.tSvc.current === 'en' ? 'bg' : 'en';
  }

  get isAuthenticated(): boolean {
    return this.auth.isAuthenticated();
  }

  get currentUser(): User | null {
    return this.auth.getCurrentUser();
  }

  logout(): void {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
